import React from 'react';
import styled from 'styled-components';

const SlidesStyled = styled.div<{ length: number, step: number }>`
  display: grid;
  grid-template-columns: repeat(${props => props.length}, 100%);
  transition: left 0.75s;
  position: relative;
  ${props =>
    Array.from({ length: props.length }).map((x, i) =>
      ''.concat("&[step='", i.toString(), "'] { left: -", i.toString(), '00%;}')
    )}
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Slides = ({ length, step, children }: { length: number, step: number, children: React.ReactNode }) => {
  return (
    <SlidesStyled length={length} step={step}>
      {children}
    </SlidesStyled>
  );
};


export default Slides;
